import React from 'preact/compat';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import colors from '../colors';
import LauncherForm from '../LauncherForm';
import LauncherFeatureSelector from '../LauncherFeatureSelector';
import LauncherBasicFeatureSelector from '../LauncherFeatureSelector/LauncherBasicFeatureSelector';
import LauncherHeader from './LauncherHeader';
import { LauncherErrorPopup } from '../LauncherPopups';
import ScrollUpButton from '../ScrollUpButton';
import { useAdvancedMode } from '../../state/advancedModeStore';
import { useApplicationVersion } from '../../state/parameterStore';

const Launcher = ({appName}) => {
    const [advancedMode, ] = useAdvancedMode();
    const appVersion = useApplicationVersion();

    return (
        <>
            <LauncherHeader appName={appName} appVersion={appVersion} />
            <Box
                sx={{
                    maxWidth: 'calc(100% - 20px)',
                    width: 1108,
                    margin: 'auto',
                    textAlign: 'left'
                }}
            >
                <LauncherErrorPopup appName={appName} />
                <ScrollUpButton />

                <LauncherForm appName={appName} />
                { advancedMode && <PageDivider /> }
                { advancedMode ? <LauncherFeatureSelector /> : <LauncherBasicFeatureSelector /> }
            </Box>
        </>
    );
};

const PageDivider = () => {
    return (
    <Divider
        sx={{
            backgroundColor: colors.inputBorder,
            marginTop: '40px',
            marginBottom: '65px',
            borderWidth: '1px'
        }}
    />
    );
}

export default Launcher;
export { Launcher };
